export default __webpack_public_path__ + "static/media/mitigation-basement-demo-overview.d2f1fe10.jpg";